import { DataGridPro } from '@mui/x-data-grid-pro';

import { getAllLeistungen } from '../../../utils/teilleistung.ts';
import { LeistungSubGridElement, VeranstaltungElement } from './VeranstaltungListing.types.ts';
import { leistungColumns } from './veranstaltungListingColumns.tsx';

export const LeistungDetailPanel = ({ row }: { row: VeranstaltungElement }) => {
  const leistungen: LeistungSubGridElement[] = getAllLeistungen(row.teilleistungen).map((leistung) => ({
    ...row,
    ...leistung,
  }));

  return (
    leistungen.length > 1 && (
      <>
        <div className="relative grid gap-16 pl-64 pr-32 pt-8 pb-32 bg-subtle">
          <span className="label-lg">Leistungen</span>
          <div className="absolute left-24 top-20 h-70 w-16 rounded-bl border-b border-l border-default"></div>
          <DataGridPro
            columns={leistungColumns()}
            rows={leistungen}
            hideFooter
            getRowId={(row) => `${row.akaVeranstaltungId}-${row.leistungId}`}
          />
        </div>
      </>
    )
  );
};
